import { render } from "./getPassTable.vue?vue&type=template&id=c3696d56&scoped=true"
import script from "./getPassTable.vue?vue&type=script&lang=js"
export * from "./getPassTable.vue?vue&type=script&lang=js"

import "./getPassTable.vue?vue&type=style&index=0&id=c3696d56&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3696d56"]])

export default __exports__